/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetRoleSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type GetRoleRequest = {
  /**
   * The ID of the role.
   */
  id: string;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetRoleSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetRoleSecurity$outboundSchema: z.ZodMiniType<
  GetRoleSecurity$Outbound,
  GetRoleSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getRoleSecurityToJSON(
  getRoleSecurity: GetRoleSecurity,
): string {
  return JSON.stringify(GetRoleSecurity$outboundSchema.parse(getRoleSecurity));
}

/** @internal */
export type GetRoleRequest$Outbound = {
  id: string;
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const GetRoleRequest$outboundSchema: z.ZodMiniType<
  GetRoleRequest$Outbound,
  GetRoleRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
    });
  }),
);

export function getRoleRequestToJSON(getRoleRequest: GetRoleRequest): string {
  return JSON.stringify(GetRoleRequest$outboundSchema.parse(getRoleRequest));
}
